var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

require ('sweetalert')
require('slick-carousel')

//OPEN MENU HEADER
document.addEventListener("click", (evt) =>{
  const menu = document.getElementById("menuD")
  const openMenu = document.getElementById("contextMenu")
  let target = evt.target
  menu.classList.toggle("bg")

  do{
    if(target == menu){
      //alert("hola")
      openMenu.style.display = "flex"
      return;
    }
    target = target.parentNode
  }while(target){
    openMenu.style.display = "none"
    }
})

// HEADER ELEMENTS
const header = document.getElementById('header'),
header2 = document.getElementById('header2'),
sepHeader = document.getElementById('separatorHeader2')
if (sepHeader) {
  let heightHeader = header2.offsetHeight
  sepHeader.style.height = heightHeader.toString() + 'px'
}
if(header){
  window.addEventListener('scroll', function () {
    header.classList.toggle('backgroundB', window.scrollY > 50)
  })
}

//no context menu for video hero
$(document).ready(function(){
  $('#videoHero').bind('contextmenu',function() { return false; });
});


/*===== MOBILE MENU SHOW & HIDDEN =====*/
const navMenu = document.getElementById('nav-menu'),
  toggleMenu = document.getElementById('nav-toggle'),
  closeMenu = document.getElementById('nav-close')

/*SHOW*/
toggleMenu.addEventListener('click', () => {
  navMenu.classList.toggle('show')
})

/*HIDDEN*/
closeMenu.addEventListener('click', () => {
  navMenu.classList.remove('show')
})



/*===== DESKTOP MENU SHOW Y HIDDEN =====*/
const menuDesk = document.getElementById('menuDesk'),
  toggleMenu2 = document.getElementById('nav-toggle2'),
  closeMenuDesk = document.getElementById('closeMenuDesk')

/*SHOW*/
toggleMenu2.addEventListener('click', () => {
  menuDesk.classList.add('showMenuDesk')
})
/*HIDDEN*/
closeMenuDesk.addEventListener('click', () => {
  menuDesk.classList.remove('showMenuDesk')
})


//MENU FLOAT CONTACT
const float = document.getElementById('float')
const overlay = document.getElementById('overlay')
const menuCont = document.getElementById('menuCont')

float.addEventListener('click', () => {
  float.classList.toggle('closing')
  overlay.classList.toggle('showOV')
  menuCont.classList.toggle('opened')
})


//ANIMATIONS
const sr = ScrollReveal({
  distance: '30px',
  duration: 500,
  delay: 200,
  //reset: true
})

// sr.reveal(`.aboutHome img` , {origin: 'right'})
// sr.reveal(`.floatDesk` , {origin: 'right'})
// sr.reveal(`.about .pt1 img` , {origin: 'right'})
// sr.reveal(`.about .pt2 img` , {origin: 'left'})
// sr.reveal(`.itemServices .servLeft img` , {origin: 'left'})
// sr.reveal(`.itemServices .servRight img` , {origin: 'right'})
// sr.reveal(`.contact .container img` , {origin: 'right'})
sr.reveal(`.float` , {origin: 'bottom', delay: 1000})
sr.reveal(`.listPlans .item` , {origin: 'bottom'})
sr.reveal(`.listServices .item` , {origin: 'left', interval: 250, mobile: false})

// OPEN MODALS

$('.toForm').click(function () {
  var inputElement = document.getElementById('CheckIn');
  inputElement.click()
  inputElement.focus()
  $('html, body').animate({
    scrollTop: $('#reservas').offset().top - 200
  })
})

$('a.bookH').click(function () {
  $(this).modal({
    fadeDuration: 150,
    clickClose: false,
    showClose: false,
    closeClass: 'modalClose'
  });
  return false;
});
$('a.openComodityModal').click(function () {
  $(this).modal({
    fadeDuration: 150,
    clickClose: false,
    showClose: false,
    closeClass: 'modalClose'
  });
  return false;
});

$('a.openCapacityModal').click(function () {
  $(this).modal({
    fadeDuration: 150,
    clickClose: false,
    showClose: false,
    closeClass: 'modalClose'
  });
  return false;
});

$('a.openOfferModal').click(function () {
  $(this).modal({
    fadeDuration: 150,
    clickClose: false,
    showClose: false,
    closeClass: 'modalClose'
  });
  return false;
});


$('a.openCharModal').click(function () {
  $(this).modal({
    fadeDuration: 150,
    clickClose: false,
    showClose: false,
    closeClass: 'modalClose'
  });
  return false;
});

/*PAGERS*/
let title = document.title,
toRooms = document.querySelector('.toRooms'),
toRest = document.querySelector('.toRest')
toEvent = document.querySelector('.toEvent')
toBook = document.querySelector('.up')
if (title != 'Hotel El Prado'){
  toRooms.classList.replace('toRooms','toRooms2')
  toRest.classList.replace('toRest' ,'toRest2')
  toEvent.classList.replace('toEvent' ,'toEvent2')
  toBook.classList.replace('up' ,'toBook')
}

/*PAGERS*/
if(location.href.includes('/#reservas')){
  setTimeout(()=>{
    var inputElement = document.getElementById('CheckIn');
    inputElement.focus()
    inputElement.click()
  },10)
  /*
  $('html, body').animate({
    scrollTop: $('#reservas').offset().top - 100
  })
  */
}
/*
$('.up').click(function () {
  //$(window).scrollTop(0);
  var inputElement = document.getElementById('CheckIn');
  inputElement.click()
  inputElement.focus()
  $('html, body').animate({
    scrollTop: $('#reservas').offset().top - 100
  })
});
*/
$('.toRooms').click(function () {
  $('html, body').animate({
    scrollTop: $('#roomsHome').offset().top - 100
  })
})
$('.toRest').click(function () {
  $('html, body').animate({
    scrollTop: $('#restHome').offset().top - 100
  })
})
$('.toEvent').click(function () {
  $('html, body').animate({
    scrollTop: $('#eventsHome').offset().top - 100
  });
});
$('.toRooms2').click(function () {
  $(location).attr("href", "/#roomsHome").offset().top - 100;
});
$('.toRest2').click(function () {
  $(location).attr("href", "/#restHome").offset().top - 100;
});
$('.toEvent2').click(function () {
  $(location).attr("href", "/#eventsHome").offset().top - 100;
});
$('.toBook').click(function () {
  //$(window).scrollTop(0);
  $('html, body').animate({
    scrollTop: $('#reservas').offset().top - 100
  })
});

$('.btn_2_rooms').click(function(){
  var inputElement = document.getElementById('CheckIn');
  inputElement.click()
  inputElement.focus()
  $('html, body').animate({
    scrollTop: $('#reservas').offset().top - 100
  })
  //$(window).scrollTop(0);
})

$('.toHomeSpa').click(function () {
  window.location.href = "https://hotelelpradobarranquilla.com/";
});

require('./sliders')
require('./get_info')
require('./api')
require('./contact')

$('.service_home_1').click(function(){
  $('html, body').animate({
    scrollTop: $('#roomsHome').offset().top - 50
  }, 500);
})

$('.service_home_2').click(function(){
  location.href = "/planes"
})

$('.service_home_3').click(function(){
  $('html, body').animate({
    scrollTop: $('#eventsHome').offset().top - 50
  }, 500);
})

$('.service_home_4').click(function(){
  $('html, body').animate({
    scrollTop: $('#restHome').offset().top - 50
  }, 500);
})